import { useLocalSearchParams } from 'expo-router';

import Transactions from '../../../banking/components/spaces/transactions/Transactions';

const TransactionsScreen = () => {
    const { bankAccountId, syncteraAccountId } = useLocalSearchParams<{
        bankAccountId: string;
        syncteraAccountId: string;
    }>();
    return (
        <Transactions
            bankAccountId={bankAccountId}
            syncteraAccountId={syncteraAccountId}
        />
    );
};

export default TransactionsScreen;
